"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountSize = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TokenSign_1 = __importDefault(require("./TokenSign"));
const material_1 = require("@mui/material");
var AmountSize;
(function (AmountSize) {
    AmountSize[AmountSize["Big"] = 0] = "Big";
    AmountSize[AmountSize["Medium"] = 1] = "Medium";
    AmountSize[AmountSize["Small"] = 2] = "Small";
})(AmountSize = exports.AmountSize || (exports.AmountSize = {}));
const Amount = ({ size, amount, noSign, horizontal, token }) => {
    if (!token) {
        token = 'OGY';
    }
    return (amount || amount === 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        size === AmountSize.Small && (react_1.default.createElement(AmountSmall, { className: 'amount', horizontal: horizontal },
            react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 1' } }, amount.toString()),
            !noSign && react_1.default.createElement(TokenSign_1.default, { token: token }))),
        size === AmountSize.Medium && (react_1.default.createElement(AmountMedium, { className: 'amount', horizontal: horizontal },
            react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 1' } }, amount.toString()),
            !noSign && react_1.default.createElement(TokenSign_1.default, { token: token }))),
        size === AmountSize.Big && (react_1.default.createElement(AmountBig, { className: 'amount', horizontal: horizontal },
            react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 1' } }, amount.toString()),
            !noSign && react_1.default.createElement(TokenSign_1.default, { token: token }))),
        !size && !AmountSize.Big && !AmountSize.Medium && !AmountSize.Small && (react_1.default.createElement(AmountMedium, { horizontal: horizontal },
            react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 1' } }, amount.toString()),
            !noSign && react_1.default.createElement(TokenSign_1.default, { token: token }))))) : react_1.default.createElement("div", { style: { height: 33 } }));
};
exports.default = Amount;
const AmountSmall = (0, styled_components_1.default)(material_1.Box) `
  font-family: 'Monserrat', sans-serif;
  font-weight: 400;
  font-size: 1em;
  line-height: 1.1em;
  color: ${({ theme }) => theme.colors.TEXT};
  display: inline;
  width: 100%;
  > div {
    display: inline;
    word-break: break-all;
    vertical-align: middle;
  }
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  font-weight: 600;
`;
const AmountMedium = (0, styled_components_1.default)(material_1.Box) `
  font-size: 2.1875em;
  color: inherit;
  font-weight: 600;
  line-height: 1.1em;
  display: inline;
  width: 100%;
  > div {
    display: inline;
    word-break: break-all;
    vertical-align: middle;
  }
  gap: 8px;
  align-items: center;
  color: ${({ theme }) => theme.colors.TEXT};
  flex-wrap: wrap;
`;
const AmountBig = (0, styled_components_1.default)(material_1.Box) `
  font-size: 3.125em;
  line-height: 1.1em;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.TEXT};
  display: inline;
  > div {
    display: inline;
    word-break: break-all;
    vertical-align: middle;
  }
  gap: 8px;
  align-items: center;
  width: 100%;
  align-items: center;
`;
